var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-ali-jus-center m-top-2rem sa sa--up"},[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"bt-typeA bt-typeA-border d-block m-rl-auto"},[_c('span',{staticClass:"bt-typeA-border-inner font-E1"},[_vm._v("Back To Home >")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }